import React, { Component } from 'react';
import {Button, Table, Row, Col} from 'react-bootstrap';
import Icon from '../../../../components/Icon';
import { handleFieldChange } from "../../../../Utils";
import SelectWrap from "../../../../components/SelectWrap";
import countriesObj from "../../../../data/countries";
import Overlay from "../../../../components/Overlay";

const countries = { ...countriesObj, '00': 'Default' };

class CpcForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            country: '',
            cpc: props.cpc,
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleCpcChange = this.handleCpcChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if(prevProps.cpc != this.props.cpc) {
            this.setState({ cpc: this.props.cpc });
        }
    }

    handleSubmit() {
        this.props.onSubmit(this.state.cpc);
    }

    handleAdd() {
        let { country, cpc } = this.state;

        if(country) {
            cpc = { ...cpc, [country]: 0 };

            this.setState({ country: '', cpc });
        }
    }

    handleCpcChange(event) {
        const { name, value } = event.target;
        const { cpc } = this.state;

        this.setState({ cpc: { ...cpc, [name]: value }});
    }

    render() {
        const { cpc } = this.state;
        const rows = Object.keys(cpc).map(country => {
            const countryCpc = cpc[country];

            return <tr>
                <td>{countries[country]}</td>
                <td><input type="number" min={0} max={1} step={0.0001} name={country} value={countryCpc} onChange={this.handleCpcChange}/></td>
            </tr>
        })

        return (
            <Overlay onFormHide={this.props.onFormHide}>
                <div style={{minHeight: '300px'}}>
                    <Row>
                        <Col lg={6}>
                            <SelectWrap
                                values={countries}
                                label="Country:"
                                name="country"
                                onChange={this.handleFieldChange}
                                value={this.state.country}
                                required
                            />
                        </Col>
                        <Col lg={6}>
                            <label className='control-label' style={{ display: 'block', visibility: 'hidden'}}>.</label>
                            <Button style={{ height: 'auto', marginLeft: 'auto'}} bsStyle="success" onClick={this.handleAdd}>Add</Button>
                        </Col>
                    </Row>

                    <Table bordered responsive>
                        <thead>
                        <tr>
                            <th>Country</th>
                            <th>Cpc</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rows}
                        </tbody>
                    </Table>

                    <div>
                        <Button onClick={this.handleSubmit} bsStyle="success"><Icon name="floppy-o"/> Save</Button>
                    </div>
                </div>
            </Overlay>
        );
    }
}

export default CpcForm;


// WEBPACK FOOTER //
// ./src/scenes/Filler/components/CpcForm/index.js